import httpClient from "../apiClient";
import * as T from "./index.types";

export class WatchersServiceAPI {
  static runAllWatchers: T.TRunAllWatchersRequest = () =>
    httpClient.get("/funded-compliance/watcher/run-watchers");
  static checkWatchersStatus: T.TCheckWatchersStatusRequest = () =>
    httpClient.get("/funded-compliance/watcher/get-watchers-working-status");
  static updateTraderIdDb: T.TUpdateTraderIdDbRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-trader-id-db");
  static updateWatchlistNotesTable: T.TUpdateWatchlistNotesTableRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-watchlist-notesTable");
  static updateWithdrawalsTable: T.TUpdateWithdrawalsTableRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-withdrawals-table");
  static updateWatchlistTcpSteps: T.TUpdateWatchlistTcpStepsRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-watchlist-tcp-steps");
  static updateWatchlistGmCappers: T.TUpdateWatchlistGmCappersRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-watchlist-gm-cappers");
  static updateMasterBanList: T.TUpdateMasterBanListRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-master-ban-list");
  static updateFinancialsTables: T.TUpdateFinancialsTablesRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-financials-tables");
  static updateFundedTradersTable: T.TUpdateFundedTradersTableRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-funded-traders-table");
  static updateEvaluationCompletedHistoryTable: T.TUpdateEvaluationCompletedHistoryTableRequest =
    () => httpClient.get("/funded-compliance/watcher/update-evaluation-completed-history-table");
  static updateTradedAccountsTable: T.TUpdateTradedAccountsTableRequest = () =>
    httpClient.get("/funded-compliance/watcher/update-traded-accounts-table");
}
